import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';


@Component({
  selector: 'app-plan',
  templateUrl: './plan.component.html',
  styleUrls: ['./plan.component.scss']
})
export class PlanComponent implements OnInit {

  constructor(private apiService: ApiService) { }

  ngOnInit() {
  }

  buttonClicked() {
    this.apiService.buyPasses();
  }

}
